module.exports = function (e) {
  var t = {};

  function n(i) {
    if (t[i]) return t[i].exports;
    var r = t[i] = {
      i: i,
      l: !1,
      exports: {}
    };
    return e[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, i) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: i
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var i = Object.create(null);
    if (n.r(i), Object.defineProperty(i, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var r in e) {
      n.d(i, r, function (t) {
        return e[t];
      }.bind(null, r));
    }
    return i;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 0);
}([function (e, t, n) {
  e.exports = n(1);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.LayoutContext = t.minimalWidthForPushedOutContent = t.defaultTransitionEasing = t.defaultWidth = void 0;

  var i,
      r = "/Users/horm/Development/react-layout/module/index.js",
      o = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
      }
    }

    return function (t, n, i) {
      return n && e(t.prototype, n), i && e(t, i), t;
    };
  }(),
      a = n(2),
      l = (i = a) && i.__esModule ? i : {
    default: i
  },
      s = n(3);

  function u(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function d(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
  }

  var h = t.defaultWidth = "300px",
      f = t.defaultTransitionEasing = "cubic-bezier(0.41, 0.03, 0, 0.96)",
      c = 250,
      g = t.minimalWidthForPushedOutContent = 65,
      p = t.LayoutContext = l.default.createContext(),
      v = function (e) {
    function t() {
      var e, n, i;
      u(this, t);

      for (var r = arguments.length, o = Array(r), a = 0; a < r; a++) {
        o[a] = arguments[a];
      }

      return n = i = d(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(o))), i.state = {
        showLeft: !1,
        showRight: !1,
        widthOverride: null
      }, i.activeWidthOverrides = {
        left: !1,
        right: !1,

        get any() {
          return this.left || this.right;
        }

      }, i.animating = !1, i.startWidthOverride = function (e) {
        i.activeWidthOverrides[e] = !0;
      }, i.handleWindowResize = function () {
        clearTimeout(i.widthOverrideSetTimeout), i.widthOverrideSetTimeout = setTimeout(function () {
          i.setState({
            widthOverride: window.innerWidth - g + "px"
          });
        }, 25);
        var e = .01 * window.innerHeight;
        document.documentElement.style.setProperty("--vh", e + "px");
      }, i.stopWidthOverride = function (e) {
        i.activeWidthOverrides[e] = !1, i.activeWidthOverrides.any || clearTimeout(i.widthOverrideSetTimeout);
      }, i.listenForMediaChange = function () {
        var e = i.props,
            t = e.width,
            n = void 0 === t ? h : t,
            r = e.leftWidth || n,
            o = e.rightWidth || n;
        i.leftMql = window.matchMedia("(min-width: " + (parseInt(r, 10) + g) + "px)"), i.leftMql.addListener(i.handleLeftMediaChange), i.handleLeftMediaChange(i.leftMql), i.rightMql = window.matchMedia("(min-width: " + (parseInt(o, 10) + g) + "px)"), i.rightMql.addListener(i.handleRightMediaChange), i.handleRightMediaChange(i.rightMql);
      }, i.handleLeftMediaChange = function (e) {
        !e.matches ? i.startWidthOverride("left") : i.stopWidthOverride("left");
      }, i.handleRightMediaChange = function (e) {
        !e.matches ? i.startWidthOverride("right") : i.stopWidthOverride("right");
      }, i.stopListenForMediaChange = function () {
        i.leftMql.removeListener(i.handleLeftMediaChange), i.rightMql.removeListener(i.handleRightMediaChange), i.stopWidthOverride("left"), i.stopWidthOverride("right");
      }, i.onToggle = function (e) {
        var t = e.left,
            n = e.right;
        return i.animating ? Promise.resolve() : new Promise(function (e) {
          i.animating = !0;
          var r = t || n;
          document.activeElement && document.activeElement.blur(), r && i.disableScroll(!0), i.setState({
            showLeft: t,
            showRight: n
          }, function () {
            setTimeout(function () {
              i.animating = !1, r || i.disableScroll(!1), e();
            }, c);
          });
        });
      }, i.onOverlayClick = function (e) {
        e.preventDefault(), i.contextActions.hideBoth();
      }, i.contextActions = {
        showLeft: function showLeft() {
          return i.onToggle({
            left: !0,
            right: !1
          });
        },
        hideLeft: function hideLeft() {
          return i.onToggle({
            left: !1
          });
        },
        toggleLeft: function toggleLeft() {
          return i.onToggle({
            left: !i.state.showLeft,
            right: !1
          });
        },
        showRight: function showRight() {
          return i.onToggle({
            right: !0,
            left: !1
          });
        },
        hideRight: function hideRight() {
          return i.onToggle({
            right: !1
          });
        },
        toggleRight: function toggleRight() {
          return i.onToggle({
            right: !i.state.showRight,
            left: !1
          });
        },
        hideBoth: function hideBoth() {
          return i.onToggle({
            left: !1,
            right: !1
          });
        }
      }, d(i, n);
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, e), o(t, [{
      key: "componentDidMount",
      value: function value() {
        c = parseInt(this.props.speed || 300), this.listenForMediaChange(), this.handleWindowResize(), window.addEventListener("resize", this.handleWindowResize, !1);
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.stopListenForMediaChange(), window.removeEventListener("resize", this.handleWindowResize), this.disableScroll(!1);
      }
    }, {
      key: "disableScroll",
      value: function value(e) {
        if (!this.defaultBodyOverflow) {
          var t = getComputedStyle(document.body);
          this.defaultBodyOverflow = t.overflow;
        }

        document.body.style.overflow = e ? "hidden" : this.defaultBodyOverflow;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
            t = e.left,
            n = e.right,
            i = e.width,
            o = void 0 === i ? h : i,
            a = e.transitionEasing,
            u = void 0 === a ? f : a,
            d = e.leftWidth,
            g = e.rightWidth,
            v = e.blurContentOnShow,
            w = e.transitionProp,
            m = void 0 === w ? "left" : w,
            y = e.children,
            b = this.state.widthOverride,
            O = this.activeWidthOverrides.left ? b : d || o,
            _ = this.activeWidthOverrides.right ? b : g || o,
            x = this.state,
            C = x.showLeft,
            W = x.showRight,
            M = "0px";

        C ? M = O : W && (M = "-" + _);
        var E = t || null,
            L = n || null,
            P = v;
        v && "boolean" == typeof v && (P = "3px");
        var S = {
          leftShown: C,
          rightShown: W,
          contentPushed: M
        };
        return l.default.createElement(p.Provider, {
          value: {
            state: S,
            actions: this.contextActions
          },
          __source: {
            fileName: r,
            lineNumber: 229
          }
        }, l.default.createElement(s.Outer, {
          showLeft: C,
          showRight: W,
          leftWidth: O,
          rightWidth: _,
          speed: c,
          transitionProp: m,
          transitionEasing: u,
          __source: {
            fileName: r,
            lineNumber: 235
          }
        }, (C || W) && l.default.createElement(s.ClickOverlay, {
          showLeft: C,
          showRight: W,
          leftWidth: O,
          rightWidth: _,
          onClick: this.onOverlayClick,
          transitionProp: m,
          transitionEasing: u,
          __source: {
            fileName: r,
            lineNumber: 245
          }
        }), l.default.createElement(s.Content, {
          leftShown: C,
          rightShown: W,
          blurContentOnShow: P,
          speed: c,
          transitionProp: m,
          transitionEasing: u,
          __source: {
            fileName: r,
            lineNumber: 255
          }
        }, y), E && l.default.createElement(s.Left, {
          width: O,
          show: C,
          speed: c,
          transitionProp: m,
          transitionEasing: u,
          __source: {
            fileName: r,
            lineNumber: 266
          }
        }, l.default.createElement(E, {
          shown: C,
          __source: {
            fileName: r,
            lineNumber: 273
          }
        })), L && l.default.createElement(s.Right, {
          width: _,
          show: W,
          speed: c,
          transitionProp: m,
          transitionEasing: u,
          __source: {
            fileName: r,
            lineNumber: 277
          }
        }, l.default.createElement(L, {
          shown: W,
          __source: {
            fileName: r,
            lineNumber: 284
          }
        }))));
      }
    }]), t;
  }(a.Component);

  t.default = v;
}, function (e, t) {
  e.exports = require("react");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.ClickOverlay = t.Right = t.Left = t.Content = t.Outer = void 0;
  var i,
      r = h(["\n  position: relative;\n  ", ";\n"], ["\n  position: relative;\n  ", ";\n"]),
      o = h(["\n  position: relative;\n  z-index: 2;\n  overflow-x: ", ";\n  background: ", ";\n  ", ";\n  ", ";\n"], ["\n  position: relative;\n  z-index: 2;\n  overflow-x: ", ";\n  background: ", ";\n  ", ";\n  ", ";\n"]),
      a = h(["\n  position: fixed;\n  top: 0;\n  z-index: 1;\n  ", "\n  overflow-x: hidden;\n  overflow-y: auto;\n  width: ", ";\n  ", ";\n"], ["\n  position: fixed;\n  top: 0;\n  z-index: 1;\n  ", "\n  overflow-x: hidden;\n  overflow-y: auto;\n  width: ", ";\n  ", ";\n"]),
      l = h(["\n  position: fixed;\n  top: 0;\n  z-index: 1;\n  ", "\n  overflow-x: hidden;\n  overflow-y: auto;\n  transition: right ", "ms ", ";\n  width: ", ";\n  ", ";\n"], ["\n  position: fixed;\n  top: 0;\n  z-index: 1;\n  ", "\n  overflow-x: hidden;\n  overflow-y: auto;\n  transition: right ", "ms ", ";\n  width: ", ";\n  ", ";\n"]),
      s = h(["\n  position: fixed;\n  top: 0;\n  ", "\n  width: 100vw;\n  z-index: 3;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n\n  ", ";\n"], ["\n  position: fixed;\n  top: 0;\n  ", "\n  width: 100vw;\n  z-index: 3;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n\n  ", ";\n"]),
      u = n(4),
      d = (i = u) && i.__esModule ? i : {
    default: i
  };

  function h(e, t) {
    return Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(t)
      }
    }));
  }

  var f = "\n  height: 100vh;\n  height: calc(var(--vh, 1vh) * 100);\n";

  function c(e) {
    return e.showLeft ? e.leftWidth : e.showRight ? "-" + e.rightWidth : "0";
  }

  function g(e) {
    return function (t) {
      var n = parseInt(t.width, 10),
          i = 0;
      return "transform" === t.transitionProp ? "\n        " + e + ": -" + n + "px;\n      " : (t.show || (i = n), "\n      " + e + ": -" + i + "px;\n      transition: " + e + " " + t.speed + "ms " + t.transitionEasing + ";\n      will-change: " + e + ";\n    ");
    };
  }

  t.Outer = d.default.div.attrs({
    className: "crystallize-layout"
  })(r, function (e) {
    return "transform" === e.transitionProp ? "\n      transition: transform " + e.speed + "ms " + e.transitionEasing + ";\n      will-change: transform;\n      transform: translate3d(" + c(e) + ", 0, 0);\n    " : "\n    transition: left " + e.speed + "ms " + e.transitionEasing + ";\n    will-change: left;\n    left: " + c(e) + ";\n  ";
  }), t.Content = d.default.div.attrs({
    className: "crystallize-layout__content"
  })(o, function (e) {
    return e.showLeft || e.showRight ? "hidden" : "visible";
  }, function (e) {
    return e.background;
  }, function (e) {
    return e.blurContentOnShow && "\n    transition: filter " + function (e) {
      return e.speed;
    } + "ms " + function (e) {
      return e.transitionEasing;
    } + ";\n  ";
  }, function (e) {
    return e.blurContentOnShow && (e.leftShown || e.rightShown) && "\n    filter: blur(" + e.blurContentOnShow + ");\n  ";
  }), t.Left = d.default.div.attrs({
    className: "crystallize-layout__menu crystallize-layout__menu--left"
  })(a, f, function (e) {
    return e.width || "300px";
  }, g("left")), t.Right = d.default.div.attrs({
    className: "crystallize-layout__menu crystallize-layout__menu--right"
  })(l, f, function (e) {
    return e.speed;
  }, function (e) {
    return e.transitionEasing;
  }, function (e) {
    return e.width || "300px";
  }, g("right")), t.ClickOverlay = d.default.div.attrs({
    className: "crystallize-layout__click-overlay"
  })(s, f, function (e) {
    return "transform" === e.transitionProp ? "left: 0;" : "\n      left: " + c(e) + "\n    ";
  });
}, function (e, t) {
  e.exports = require("styled-components");
}]);